'use strict';

angular.module('cimerFrontEndApp').controller('CustomSurveyCtrl',
    ['$scope', '$http', 'SurveyService', '$uibModal', '$q', '$routeParams', 'ApiUrl',
        '$location', 'Session', 'TextEditorService', 'authorized', function ($scope, $http, SurveyService, $uibModal,
            $q, $routeParams, ApiUrl, $location, Session, TextEditorService, authorized) {

    //NOTE: some unfortunate nomenclature here:
    //base survey is the starting survey for a new custom survey, which can be an older custom survey
    //the BaseSurveyID is the ID of the fundamental NSF division survey from which the base survey derived and over which aggregate reporting will happen

    if (!Session.getSessionObject().isAuthenticated) {
        $location.url('/');
        return;
    }
    // Route the user away if they're not authorized for this grant
    if (!authorized) {
        $location.url('/');
        return;
    }
    
    //set up empty model
    $scope.customSurvey = {
        GrantID: null,
        baseSurvey: {},
        surveyName: '',
        infoText: '',
        sections: [],
        ExcludedBaseSurveyQuestionIDs: [],
        emailMessage: ''
    };
    $scope.baseSurvey = {};
    $scope.curatedQuestions = [];
    $scope.baseSurveys = [];
    $scope.surveySections = [];


    $scope.QuestionRoleEnum = SurveyService.QuestionRole;
    $scope.tinymceOptions = TextEditorService.GetTextEditorConfig();
    $scope.sortableOptions = {
        handle: '.section-drag-and-drop'
    };
    $scope.emailSectionIsCollapsed = true;
    $scope.emailTextMaxLength = 2000;
    $scope.surveyNameMaxLength = 255;
    $scope.surveyDescriptionMaxLength = 5000;

    //pull values from the url query parameters
    var grantID = $routeParams.id;
    $scope.customSurvey.GrantID = grantID;
    if ($routeParams.hasOwnProperty('edit')) {
        $scope.lockBaseSurvey = true;  //when editing an existing survey, disable select base survey
        $scope.customSurvey.baseSurvey.SurveyID = $routeParams.edit;
    }
    else {
        $scope.lockBaseSurvey = false;
    }


    $scope.directorID = null;
    var _grantapiUrl = ApiUrl.url('/Grant/');
    $scope.showPage = false;
    $scope.showInfoText = false;
    //grab relevant data from database, route away if invalid
    $http.get(_grantapiUrl + 'GetGrantAndDirector?grantID=' + grantID).then(function (response) {
        if (response.data) {
            $scope.directorID = response.data.DirectorID;
            $scope.grantName = response.data.GrantName;

            if ($scope.lockBaseSurvey) { // we are editing an existing custom survey
                //check first to make sure survey is editable
                SurveyService.isSurveyEditable($scope.customSurvey.baseSurvey.SurveyID, $scope.directorID).then(function (result) {
                    if (result) {
                        $scope.loadBaseSurvey(false);
                        $scope.showPage = true;
                    }
                    else {
                        $location.url('/director');
                    }
                }, function () {
                    $location.url('/director');
                });
            }
            else { // new custom survey
                $scope.showPage = true;
                SurveyService.getBaseSurveys(grantID, $scope.directorID).then(function (result) {
                    $scope.baseSurveys = result;
                 
                });
            }

        }
        else {
            $location.path('error');
        }
    }, function () {
        $location.path('error');
    });

    var dataRequests = [SurveyService.getCuratedSectionTags()];
    $q.all(dataRequests)
        .then(function (data) {
            $scope.tags = data[0];
        });

    $scope.loadBaseSurvey = function (baseSurveyChanged) {

        //reset base survey
        $scope.baseSurvey = {};

        // Clear out info from the old base survey 
        for (var i = 0; i < $scope.surveySections.length; i++) {
            // Remove the previous base sections
            if ($scope.surveySections[i].SectionRoleID === 1) {
                $scope.surveySections.splice(i--, 1);
                continue;
            }
            // Remove old custom sections from the old base survey (i.e. those with a SectionID)
            // This includes any curated question groups
            else {
                if ($scope.surveySections[i].hasOwnProperty('SectionID') && $scope.surveySections[i].SectionID !== null) {
                    $scope.surveySections.splice(i--, 1);
                }
            }
        }

        // Hold on to all the new custom sections or curated question sections
        var newSections = angular.copy($scope.surveySections);
        // Clear out the surveySections array
        $scope.surveySections = [];

        // If they're changing the selected base survey, wipe out the previously saved list of excluded questions
        if (baseSurveyChanged) {
            $scope.customSurvey.ExcludedBaseSurveyQuestionIDs = [];
        }

        SurveyService.getSurveyForEdit($scope.customSurvey.baseSurvey.SurveyID).then(function (result) {
            $scope.baseSurvey = {
                SurveyID: result.SurveyID,
                numQuestions: result.numQuestions,
                TargetID: result.TargetID,
                BaseSurveyID: result.BaseSurveyID, //this is the original BASE survey supplied by NSF
                Name: result.Name,
                infoText: result.InfoText,
                emailMessage: result.EmailText,
                Sections: []
            };
            var i;
            for (i = 0; i < result.Sections.length; i++) {
                // Grab all the base sections' raw data for use in excluding questions and preview
                if (result.Sections[i].SectionRoleID === 1) {
                    $scope.baseSurvey.Sections.push(result.Sections[i]);
                }
                var tempObj = {
                    sectionName: result.Sections[i].SectionText,
                    SectionID: result.Sections[i].SectionID,
                    SectionRoleID: result.Sections[i].SectionRoleID,
                    questions: SurveyService.parseQuestionPrompts(result.Sections[i].QuestionPrompts)
                };
                // Keep a record of all the survey sections together (base and custom)
                $scope.surveySections.push(tempObj);
                
            }
            
            // Add back any new custom/curated sections we saved earlier
            for (i = 0; i < newSections.length; i++) {
                // Existing sections are already in the right format, so just add them to the end
                $scope.surveySections.push(newSections[i]);
            }

            // Now that we have all the sections, set the base sections to be collapsed by default
            for (i = 0; i < $scope.surveySections.length; i++) {
                $scope.surveySections[i].collapse = $scope.surveySections[i].SectionRoleID === 1; // 1 is base section
            }

            // If editing an existing survey
            if ($scope.lockBaseSurvey) {
                $scope.customSurvey.SurveyID = $scope.baseSurvey.SurveyID;
                $scope.customSurvey.surveyName = $scope.baseSurvey.Name;
                $scope.customSurvey.infoText = $scope.baseSurvey.infoText;
                $scope.customSurvey.emailMessage = $scope.baseSurvey.emailMessage;
                $scope.customSurvey.baseSurvey = {
                    SurveyID: $scope.baseSurvey.SurveyID,
                    TargetID: $scope.baseSurvey.TargetID,
                    BaseSurveyID: $scope.baseSurvey.BaseSurveyID,
                    Name: $scope.baseSurvey.Name
                };

                // Get a list of core questions the user previously marked as ExcludeFromReports
                $scope.customSurvey.ExcludedBaseSurveyQuestionIDs =
                    SurveyService.extractExcludedBaseSurveyQuestionIDs($scope.baseSurvey.Sections);

            } else { // If creating a new survey
                // Set the email text to the default project text
                $scope.customSurvey.emailMessage = result.EmailText;
            }

            //load curated questions based on target ID and the project group of the grant
            SurveyService.getCuratedQuestionGroupsForCustomSurvey(result.TargetID, $scope.customSurvey.GrantID).then(function (result) {
                $scope.curatedQuestions = result;
            });

        });

    };



    $scope.addNewSection = function () {
        $scope.surveySections.push({
            sectionName: '<p>Add new section name here</p>', // placeholder text
            SectionID: null,
            SectionRoleID: SurveyService.QuestionRole.Custom,
            questions: [],
            collapse: false
        });
    };

    $scope.removeSection = function (index) {
        // Can't remove a base survey section
        if ($scope.sectionIsBase(index)) { return; }
        $scope.surveySections.splice(index, 1);
    };

    

    $scope.displayCoreQuestionsExclusionInterface = function () {

        // Assemble the survey name & sections, so we can pass it to the modal controller
        var survey = {};
        
        survey.SurveyName = $scope.customSurvey.surveyName;
        survey.Sections = [];
        
        var i;

        for (i = 0; i < $scope.baseSurvey.Sections.length; i++) {
            survey.Sections.push($scope.baseSurvey.Sections[i]);
        }
        // verify only questions in our exclude list have that property set (becomes an issue when this is re-opened after being canceled)
        for (var i = 0; i < survey.Sections.length; i++) {
            for (var j = 0; j < survey.Sections[i].QuestionPrompts.length; j++) {

                // Single, multi, and Text questions will have ExcludeFromReports exposed at this level
                if (survey.Sections[i].QuestionPrompts[j].hasOwnProperty('ExcludeFromReports')) {
                    var questionID = survey.Sections[i].QuestionPrompts[j].QuestionID;
                    survey.Sections[i].QuestionPrompts[j].ExcludeFromReports = false;  // default this to false
                    for (var l = 0; l < $scope.customSurvey.ExcludedBaseSurveyQuestionIDs.length; l++) {
                        if ($scope.customSurvey.ExcludedBaseSurveyQuestionIDs[l] === questionID) {
                            survey.Sections[i].QuestionPrompts[j].ExcludeFromReports = true;
                        }
                    }
                }

                // Matrix questions will have ExcludeFromReports exposed within a child Questions property
                if (survey.Sections[i].QuestionPrompts[j].hasOwnProperty('Questions')) {
                    for (var k = 0; k < survey.Sections[i].QuestionPrompts[j].Questions.length; k++) {
                        var questionID = survey.Sections[i].QuestionPrompts[j].Questions[k].QuestionID;
                        survey.Sections[i].QuestionPrompts[j].Questions[k].ExcludeFromReports = false;   // default this to false
                        for (var m = 0; m < $scope.customSurvey.ExcludedBaseSurveyQuestionIDs.length; m++) {
                            if ($scope.customSurvey.ExcludedBaseSurveyQuestionIDs[m] === questionID) {
                                survey.Sections[i].QuestionPrompts[j].Questions[k].ExcludeFromReports = true;
                            }
                        }
                    }
                }
            }
        }

        var coreQuestionsExclusionModalInterface =  $uibModal.open({
            animation: true,
            templateUrl: '/Content/Templates/survey/coreQuestionsExclusionModal.html',
            controller: 'CoreQuestionsExclusionModalCtrl',
            size: 'lg',
            resolve: {
              
                survey: function () {
                    return survey;
                }
                
            }
        });

        // Resolved when modal's Saved/Confirmed button is clicked
        coreQuestionsExclusionModalInterface.result.then(function (result) {

            // Put the list of selected question IDs from the modal into $scope
            $scope.customSurvey.ExcludedBaseSurveyQuestionIDs = result.ExcludedBaseSurveyQuestionIDs;

        }, function() {
            // modal cancelled, do nothing
        });

    };

    $scope.displayCuratedQuestions = function (index) {
        var curatedQuestionsModalInstance = $uibModal.open({
            animation: true,
            templateUrl: '/Content/Templates/survey/curatedQuestionsModal.html',
            controller: 'CuratedQuestionsModalCtrl',
            size: 'lg',
            resolve: {
                curatedQuestions: function () {
                    return $scope.curatedQuestions;
                },
                tags: function () {
                    return $scope.tags;
                }
            }
        });

        curatedQuestionsModalInstance.result.then(function(sectionID) { // This is the sectionID of the original curated question group
            //load this curated question group and inject into the survey
            SurveyService.loadCuratedQuestionGroup(sectionID).then(function (result) {

                var curatedQuestionGroup = {
                    questions: SurveyService.parseQuestionPrompts(result.QuestionPrompts),
                    sectionTitle: result.SectionTitle,
                    sectionName: result.SectionText,
                    TargetID: result.QuestionPrompts[0].TargetID,
                    SectionRoleID: SurveyService.QuestionRole.Curated,  //this is a curated question by construction
                    SectionID: null, //we want to copy this, so it will need a new id
                    CompositeScoreID: result.CompositeScoreID
                };
                //we also need new section index ids, so null the old ones out
                for (var i = 0; i < curatedQuestionGroup.questions.length; i++) {
                    //if it is a matrix question, need another loop
                    if (curatedQuestionGroup.questions[i].details.hasOwnProperty('Questions')) {
                        for (var k = 0; k < curatedQuestionGroup.questions[i].details.Questions.length; k++) {
                            curatedQuestionGroup.questions[i].details.Questions[k].SectionIndexID = null;
                        }
                    }
                    else {
                        curatedQuestionGroup.questions[i].details.SectionIndexID = null;
                    }
                }
                
                $scope.surveySections.push(curatedQuestionGroup);
            }, function (err) {
                //display error message?
            });


        }, function() {
            //modal cancelled, do nothing
        });

    };


            

    //save the survey here
    $scope.formSubmitted = false;
    var getSurveyForSave = function () {

        $scope.formSubmitted = true;

        if (!$scope.customSurveyForm.$invalid) { // we can submit this

            var survey = {};
            var tempObj = {};
            var tempQuestion = {};
            var question = {};
            var sortOrder = 0;
            //note, currently written for new survey only, will have to revisit
            //for editing of saved custom surveys
            survey.Name = $scope.customSurvey.surveyName;

            if ($scope.customSurvey.hasOwnProperty('SurveyID')) { //EDIT existing survey
                survey.baseSurveyID = null;
                survey.SurveyID = $scope.customSurvey.SurveyID;
            }
            else { //SAVE new survey with known base survey
                survey.baseSurveyID = $scope.baseSurvey.BaseSurveyID;
                survey.SurveyID = null;
            }

            survey.ExcludedBaseSurveyQuestionIDs = $scope.customSurvey.ExcludedBaseSurveyQuestionIDs;
            survey.GrantID = grantID;
            survey.TargetID = $scope.customSurvey.baseSurvey.TargetID; //need to add this to all new questions
            survey.OwningUserID = $scope.directorID; //director will own this survey
            survey.InfoText = $scope.customSurvey.infoText;
            survey.EmailText = $scope.customSurvey.emailMessage;
            survey.Sections = [];

            // add all the sections
            for (var i = 0; i < $scope.surveySections.length; i++) {
                var section = $scope.surveySections[i];
                tempObj = {
                    SectionID: section.SectionID,
                    SectionTitle: $scope.customSurvey.surveyName,
                    SectionText: section.sectionName,
                    SectionSortOrder: i + 1,
                    SectionRoleID: section.SectionRoleID,
                    Questions: [],
                    CompositeScoreID: section.CompositeScoreID
                };

                // We're not going to trust anything about the base survey sections coming from the front-end
                // except the sort order of the sections
                sortOrder = 1;
                for (var j = 0; j < section.questions.length; j++) {
                    //if it is a matrix question, need another loop
                    if (section.questions[j].details.hasOwnProperty('Questions')) {
                        for (var k = 0; k < section.questions[j].details.Questions.length; k++) {
                            question = section.questions[j].details.Questions[k];
                            tempQuestion = {
                                QuestionID: question.QuestionID,
                                SectionIndexID: question.SectionIndexID,
                                SortOrder: sortOrder,
                                TargetID: survey.TargetID,
                                QuestionScale: {
                                    QuestionScaleID: question.QuestionScaleID,
                                    OwnerID: question.OwnerID,
                                    Answers: question.QuestionScale
                                },
                                QuestionTypeID: question.QuestionTypeID,
                                Text: question.Text,
                                QuestionLabel: question.QuestionLabel,
                                QuestionPromptID: section.questions[j].details.QuestionPromptID,
                                QuestionPromptText: section.questions[j].details
                                    .QuestionPromptText,
                                QuestionRoleID: SurveyService.QuestionRole.Custom,
                                QuestionBranchIDs: [],
                                MatrixQuestionGroup: j.toString(), //current matrix group. The backend maps this to a string property for some reason
                                Required: false
                            };
                            // Add all the question branch IDs to the question
                            for (var l = 0; l < question.QuestionBranches.length; l++) {
                                for (var m = 0; m < question.QuestionBranches[l].ParentQuestions.length; m++) {
                                    tempQuestion.QuestionBranchIDs.push(question.QuestionBranches[l].ParentQuestions[m].ScaleAnswers.map(sa => sa.QuestionBranch.getID().toString()));
                                }
                            }
                            tempQuestion.QuestionBranchIDs = tempQuestion.QuestionBranchIDs.flat();
                            // Don't need to update scale answers here because matrix questions can't be parents
                            tempObj.Questions.push(tempQuestion);
                            sortOrder++;
                        }
                    }
                    //otherwise just add the question
                    else {
                        question = section.questions[j].details;
                        tempQuestion = {
                            QuestionID: question.QuestionID,
                            SectionIndexID: question.SectionIndexID,
                            SortOrder: sortOrder,
                            TargetID: survey.TargetID,
                            QuestionScale: {
                                QuestionScaleID: question.QuestionScaleID,
                                OwnerID: question.OwnerID,
                                Answers: question.QuestionScale
                            },
                            QuestionTypeID: question.QuestionTypeID,
                            Text: question.Text,
                            QuestionLabel: question.QuestionLabel,
                            QuestionPromptID: question.QuestionPromptID,
                            QuestionPromptText: '',
                            QuestionRoleID: SurveyService.QuestionRole.Custom,
                            QuestionBranchIDs: [],
                            MatrixQuestionGroup: null,
                            Required: question.Required
                        };
                        // Add all the question branch IDs to the question
                        for (var n = 0; n < question.QuestionBranches.length; n++) {
                            for (var o = 0; o < question.QuestionBranches[n].ParentQuestions.length; o++) {
                                tempQuestion.QuestionBranchIDs.push(question.QuestionBranches[n].ParentQuestions[o].ScaleAnswers.map(sa => sa.QuestionBranch.getID().toString()));
                            }
                        }
                        tempQuestion.QuestionBranchIDs = tempQuestion.QuestionBranchIDs.flat();
                        // Add branch IDs to scale objects
                        for (n = 0; n < question.QuestionScale.length; n++) {
                            tempQuestion.QuestionScale.Answers[n].TempBranchID = question.QuestionScale[n].QuestionBranch.TempBranchID;
                        }
                        tempObj.Questions.push(tempQuestion);
                        sortOrder++;
                    }
                }
                survey.Sections.push(tempObj);
            }

            return survey;
        } else { return null; } // invalid survey form

    }; // end getSurveyForSave


    $scope.saveCustomSurvey = function (exitAfterSave, redirectToAddUsers) {
        $scope.formSubmitted = true;
        if ($scope.customSurveyForm.$invalid) {
            return; // Don't let them save, the page will display the errors for them
        }
        var survey = getSurveyForSave();
        SurveyService.saveCustomSurvey(survey).then(function (result) {
            // If it was a new survey, set the survey ID to the newly generated custom survey ID (this is unfortunate naming as baseSurvey.SurveyID here is in fact the custom survey ID)
            $scope.customSurvey.baseSurvey.SurveyID = result;

            if (!exitAfterSave && !redirectToAddUsers) {
                // Set lockBaseSurvey to true after any save. If it was a new survey that was just saved for the first time, we need to prevent them from changing the base survey
                $scope.lockBaseSurvey = true;
                $scope.formSubmitted = false; // reset this variable so errors don't show immediately as the user is adding new things
                // Clear out old sections in preparation for a full reload
                $scope.surveySections = [];
                // Reload the survey info
                $scope.loadBaseSurvey(false);
            }
            else {
                //strip query parameter
                if ($location.$$search.edit) {
                    delete $location.$$search.edit;
                    $location.$$compose();
                }
                if (exitAfterSave) {
                    $location.path('director');
                }
                if (redirectToAddUsers) {
                    $location.path('director/upload/' + $scope.customSurvey.GrantID);
                }
            }
        }, function () {
            console.log("Unable to save survey");
        });
    };


    $scope.previewSurvey = function (base) {
        var survey = {};
        var tempObj = {};

        survey.SurveyName = $scope.customSurvey.surveyName;
        survey.Sections = [];
        var i;
        var questionCount = 1;

        // If we're just displaying the base survey
        if (base) {
            // Display the base survey as it was created by the admin, not the order the user may have set relative to the custom survey sections
            for (i = 0; i < $scope.baseSurvey.Sections.length; i++) {
                survey.Sections.push($scope.baseSurvey.Sections[i]);
            }
        }
        else {
            // Display both base and custom sections in the order the user has set them
            for (i = 0; i < $scope.surveySections.length; i++) {
                var section = $scope.surveySections[i];
                // Make the survey section object
                tempObj = {
                    SectionTitle: $scope.customSurvey.surveyName,
                    SectionText: section.sectionName,
                    SectionSortOrder: i + 1,
                    QuestionPrompts: []
                };

                // Update the question numbers and matrix prompt numbers
                for (var j = 0; j < section.questions.length; j++) {
                    section.questions[j].details.questionCount = questionCount;
                    if (section.questions[j].details.hasOwnProperty('Questions')) {
                        for (var k = 0; k < section.questions[j].details.Questions.length; k++) {
                            section.questions[j].details.Questions[k].promptCount = k + 1;
                        }
                    }
                    tempObj.QuestionPrompts.push(section.questions[j].details);
                    questionCount++;
                }
                survey.Sections.push(tempObj);
            }
        }

        var previewSurveyModalInstance = $uibModal.open({
            animation: true,
            templateUrl: '/Content/Templates/survey/previewSurveyModal.html',
            controller: 'PreviewSurveyModalCtrl',
            size: 'lg',
            resolve: {
                survey: function () {
                    return survey;
                }
            }
        });

    };

    //currently just route back to the director page
    $scope.cancelSurveyCreation = function() {
        //strip query parameter
        if ($location.$$search.edit) {
            delete $location.$$search.edit;
            $location.$$compose();
        }
        $location.path('director');
    };

    $scope.sectionIsBase = function (index) {
        return $scope.surveySections[index].SectionRoleID === 1;
    };

}]);

